if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.formData = null;
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.drawerCart = document.querySelector('drawer-cart');
      this.drawerCartItems = document.querySelector('cart-items');
      this.footerCart = document.getElementById('main-cart-footer');
      this.buttonCheckout = document.getElementById('checkout');
      this.giftForm = this.dataset?.gift && this.dataset?.gift === 'gift' ? true : false;
      this.openAddCheckbox = JSON.parse(this.drawerCart.getAttribute("data-open-checkbox"));

      this.product = {
        id: this.dataset.id,
        title: this.dataset.title,
        compareAtPrice: this.dataset.compareAtPrice,
        price: this.dataset.price,
        type: this.dataset.type,
        category: this.dataset.category,
        vendor: this.dataset.vendor,
        variant: this.dataset.variant,
        sku: this.dataset.sku
      };
    }

    async onSubmitHandler(evt) {

      evt.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');
      const isColletionSection = document.getElementById('isColletionSection');
      const completeYourCartClosestButtonWrapper = evt.target.closest('.product__complete-cart__wrapper__add_to_cart-wrapper');
      const completeYourCartProductAddToCart = completeYourCartClosestButtonWrapper ? completeYourCartClosestButtonWrapper.querySelector('.btn--primary') : null;
      const completeYourCartProductWrapper = evt.target.closest('.product__complete-cart__wrapper__product-wrapper');
      const drawerWrapper = evt.target.closest('.drawer-cart__wrapper');
      const drawerCloseButton = drawerWrapper ? drawerWrapper.querySelector('.drawer-cart__close') : null;
      const isQuickAdd = evt.target.closest('.product-sizes--container');
      const productCardWrapper = evt.target.closest('.grid__item .card-wrapper');
      const isGiftProduct = this.giftForm;
      const openDrawerAddProduct = this.openAddCheckbox;


      if (isQuickAdd && productCardWrapper) {
        productCardWrapper.classList.add('keep-hover-effect');
      }

      if (submitButton.classList.contains('loading')) return;
      evt.target.classList.contains('look-page') || completeYourCartProductAddToCart ? null : this.cartNotification.setActiveElement(document.activeElement);
      isColletionSection === undefined ? this.handleErrorMessage() : false;
      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      if (this.querySelector('.loading-overlay__spinner')) {
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      this.formData = new FormData(this.form);

      await this.removePromoPropertyForm();

      evt.target.classList.contains('look-page') || completeYourCartProductAddToCart ? null : this.formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      this.formData.append('sections_url', window.location.pathname);
      config.body = this.formData;

      var settings = {
        speedOpen: 50,
        activeClass: 'is-active',
        visibleClass: 'is-visible',
      };
  
      var toggleccessibility = function (event) {
        if (event.getAttribute('aria-expanded') === 'true') {
          event.setAttribute('aria-expanded', false);
        } else {
          event.setAttribute('aria-expanded', true);
        }
      };

      var openDrawer = function (trigger) {
        var target = document.getElementById(trigger.getAttribute('aria-controls'));        
        target.classList.add(settings.activeClass);
        document.body.style.overflow = 'hidden';
        toggleccessibility(trigger);
  
        setTimeout(function () {
          target.classList.add(settings.visibleClass);
        }, settings.speedOpen);
      };

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          } else {
            if (document.querySelector("body").classList.contains('has-cart-test')) {
              window.location.href = '/cart';
            }
          }
          if (!this.product.variant) {
            let variants = document.querySelectorAll('variant-radios .product-form__input .variation-size');
            let variant_title = null;
            variants.forEach(variant => {
              if(variant.checked) {
                variant_title = variant.value;
                this.product.sku = variant.dataset.sku;
              }
            });
            this.product['variant'] = variant_title;
          }
          if (typeof addToCartGtm === 'function') {
            addToCartGtm(this.product, 1);
          }
          if (typeof addToCartGA4 === 'function') {
            addToCartGA4(this.product, 1);
          }
          if (typeof addToCartPH === 'function') {
            addToCartPH(this.product, 1);
          }
          if (typeof addToCartCriteo === 'function') {
            addToCartCriteo(this.product, 1);
          }

          if (window.giftPopup?.popupActive) {
            const popupAlreadyShown = Cookies.get('giftPopupActivated');
            if (!popupAlreadyShown) {
              if (window.giftPopup?.popupDesktop && window.giftPopup?.popupMobile) {
                if(window._klOnsite) {
                  if (window.innerWidth >= 749) {
                    window._klOnsite.push(['openForm', window.giftPopup?.popupDesktop]);
                  }
                  else {
                    window._klOnsite.push(['openForm', window.giftPopup?.popupMobile]);
                  }

                  setTimeout(() => {
                    let modalShown = document.querySelector('.needsclick');
                    if (modalShown) {
                      modalShown.style.zIndex = '999999'
                    }
                  }, 300);

                  const expirationTime = new Date(new Date().getTime() + 30 * 60 * 1000);
                  Cookies.set('giftPopupActivated', 'true', { expires: expirationTime })
                }
              }
            }
          }

          if (window.clarity) window.clarity('event', 'add_to_cart');
          
          if (!openDrawerAddProduct) {
            evt.target.querySelector("button").classList.contains("look__addproduct") || completeYourCartProductAddToCart || isGiftProduct ? false : this.cartNotification.renderContents(response);
          }
          if (evt.target.classList.contains('collection-form') && !completeYourCartProductAddToCart && productCardWrapper && isQuickAdd) {
            displayQuickAddSuccessMessage(productCardWrapper);
          }

          if (completeYourCartProductAddToCart && drawerCloseButton && completeYourCartProductWrapper) {
            const addToCartText = completeYourCartProductAddToCart.querySelector('.product__complete-cart__wrapper__add_to_cart-wrapper--add-to-cart');
            const addedToCartText = completeYourCartProductAddToCart.querySelector('.product__complete-cart__wrapper__add_to_cart-wrapper--added-to-cart');
            const sizeFormButton = evt.target.querySelector('button');
            const translatedAddedToCart = sizeFormButton ? sizeFormButton.getAttribute('data-translated-added') : null;
            completeYourCartProductWrapper.classList.add('product-added');

            if (addToCartText && addedToCartText && translatedAddedToCart) {
              addedToCartText.innerText = translatedAddedToCart;
              addToCartText.classList.add('hidden');
              addedToCartText.classList.remove('hidden');
              completeYourCartProductAddToCart.classList.add('btn--secondary');
              drawerCloseButton.click();
            }
          };
          // openDrawer(submitButton);
          this.drawerCartItems.classList.remove('is-empty');
          this.footerCart?.classList.remove('is-empty');
          
          this.buttonCheckout.disabled = false;

          let variantID = document.querySelector('li[data-id="' + response.variant_id + '"]');

          if (variantID != null) {
            let variantLine = variantID.getAttribute('data-index');
            var line = variantLine;
          } else {
            var line = 1;
          }
          
          let quantity = response.quantity;
          const body = JSON.stringify({
            line,
            quantity,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
          });
          fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
          .then((response) => response.json())
          .then((state) => {
            const parsedState = state;
            this.getSectionsToRender().forEach((section => {
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

              elementToReplace.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

            }));

            if (openDrawerAddProduct) {
              window.requestAnimationFrame(() => {
                evt.target.querySelector("button").classList.contains("look__addproduct") || completeYourCartProductAddToCart || isGiftProduct ? false : this.drawerCart.classList.add("is-active");
                evt.target.querySelector("button").classList.contains("look__addproduct") || completeYourCartProductAddToCart || isGiftProduct ? false : this.drawerCart.classList.add("is-visible");
              });
            }
            
          }).catch((e) => {
            console.error(e);
          })
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          if (this.querySelector('.loading-overlay__spinner')) {
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          }
          if (typeof calcCartItemsHeight === 'function') {
            calcCartItemsHeight();
          }
        });
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    async removePromoPropertyForm() {

      const inputPromo = this.form.querySelector('input[name="properties[_promo]"]');
      if (!inputPromo) return;

      try {
        const response = await fetch(`${routes.cart_url}.js`);
        
        if (!response.ok) return;
        
        const cart = await response.json();
    
        if (cart && cart.items) {
          const hasPromoProperty = cart.items.some(item =>
            item.properties && item.properties._promo !== undefined
          );
    
          if (hasPromoProperty) {
            this.formData.delete('properties[_promo]');
          }
        }
      } catch (error) {
        console.log(error);
      }
    }

    getSectionsToRender() {
      if (window.location.pathname != '/cart') {
        return [
          {
            id: "drawer-cart",
            section: window.renderCartSection,
            selector: "#drawer-cart"
          },
          {
            id: "cart-icon-bubble",
            section: "cart-icon-bubble",
            selector: ".shopify-section",
          }
        ];
      } else {
        return [
          {
            id: "cart-icon-bubble",
            section: "cart-icon-bubble",
            selector: ".shopify-section"
          }, {
            id: "cart-content",
            section: document.getElementById("main-cart-items").dataset.id,
            selector: "#cart-content"
          }, {
            id: "main-cart-footer",
            section: document.getElementById("main-cart-footer").dataset.id,
            selector: ".js-contents",
          }
        ];
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
  
}